/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_SentInputs */

const cs_tasks_protocol_sent = /** @type {(inputs: Tasks_Protocol_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odesláno k podpisu`)
};

const en_tasks_protocol_sent = /** @type {(inputs: Tasks_Protocol_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent for signing`)
};

/**
* | output |
* | --- |
* | "Sent for signing" |
*
* @param {Tasks_Protocol_SentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_sent = /** @type {((inputs?: Tasks_Protocol_SentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_SentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_sent(inputs)
	return cs_tasks_protocol_sent(inputs)
});